module.exports = "/_next/static/images/hypurr-paw-bd903958b2ed2c09420255bebed460ad.svg";